import styled from "styled-components";
import { Grid } from "@material-ui/core";

const TableGridItem = styled(Grid)`
  padding: ${({ padding }) => (padding ? "10px 25px" : 0)};
  border-bottom: solid ${({ hidden = false }) => (hidden ? 0 : 1)}px #ebeef1;
`;

export default TableGridItem;
